module.exports = __webpack_public_path__ + "static/media/027.de3f3349.jpg";